import './MapPointMarker.less';
import { useAppDispatch } from '../../../store/hooks/hooks';
import { selectGeometry, selectSyncGeometry } from '../../../store/slice/mapSlice';
import { Point } from '../../../models/Geometries';
import { Marker } from 'react-map-gl';

interface Props {
  point: Point;
  onCliked: (point: Point) => any;
  isSync?: boolean;
}

function MapPointMarker({ point, onCliked, isSync }: Props) {
  const dispatch = useAppDispatch();

  /*
    Se incluye la variable isSync para diferenciar si se selecciono 
    una geometria sincronizada o no, y asi hacer el dispatch en el redux y poder mostrar el
    modal correspondiente
  */

  return (
    <Marker onClick={(e) => {
              e.originalEvent.stopPropagation();
              if(isSync){
                dispatch(selectSyncGeometry(point));
              }else{
                dispatch(selectGeometry(point));
              }
              onCliked(point)
            }}
            longitude={point.longitud}
            latitude={point.latitud} color={point.color}>
    </Marker>
  );
}

export default MapPointMarker;
